var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('AppNavigation'),_c('div',{attrs:{"id":"app-main"}},[(_vm.isSidebarVisible)?_c('AppSidebar',{staticClass:"shrink-0"}):_vm._e(),_c('main',{staticClass:"grow",attrs:{"id":"app-content"}},[_c('RouterView')],1)],1),_c('GlobalLoading'),_c('LastRoom'),_c('RecentlyViewedRooms')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }